import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import CartContext from "../../context/cart";
import UserContext from "../../context/user";
import Title from "../title";
import Translate from "../translate";
import imagePh from "../../images/placeholder-image.png";
import { translateCart } from "../../utils/lang";
import AppError from "../app-error";

const CartDetail = ({ handleCartSelection }) => {
  const { logged, callApi } = useContext(UserContext);
  const {
    appLang,
    labels,
    status,
    currentSectionIndex,
    showDetail: cartId,
    setShowDetail,
  } = useContext(CartContext);

  const { isFetching, error, data } = useQuery(
    ["cart-detail", cartId],
    () => callApi(`/cart/${cartId}`),
    {
      enabled: logged,
      select: (data) => translateCart(data, appLang),
    }
  );

  return error ? (
    <AppError labels={labels} />
  ) : (
    <>
      <Title showStepper={false} handleNavigation={() => setShowDetail(null)}>
        {(labels?.WELFARE_CART_DETAIL_TITLE || "Content of [CART_NAME] cart").replace(
          "[CART_NAME]",
          data?.title || ""
        )}
      </Title>
      {isFetching ? (
        <div className="loading-spinner mt" />
      ) : (
        <div className="wrapper wrapper--detail">
          <Translate className="carrello-content__detail" html={data?.cartContent} />
          <div className="carrello-content__detail-img">
            <img
              src={data?.coverUrl || imagePh}
              className="carrello-content__img"
              alt={data?.title}
            />
            {status === "cart-selection" && currentSectionIndex === 0 && (
              <div className="carrello-content__cta-detail">
                <button
                  className="button small light carrello-content__cta"
                  id={data?.id}
                  onClick={handleCartSelection}
                >
                  <span>{labels?.WELFARE_CART_CTA || "Choose this one"}</span>
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default CartDetail;
